const en = {
  seo: {
    home: {
      title: "Wild Spoon — Private chef in Granada, Spain | Private dining in the Albaicín",
      description: "Wild Spoon, private gastronomic experiences by Edu Vincent, Franco-Catalan self-taught cook in Granada's Albaicín: private dinners in the Albaicín, or a private chef at your rental. Groups of 4 or more.",
    },
    reservas: {
      title: "Book your experience — Wild Spoon | Private chef Granada",
      description: "Request your private dinner with Wild Spoon: at Edu's home in Granada's Albaicín, or with a private chef at your place. Edu personally confirms availability.",
    },
    legal: {
      title: "Legal information — Wild Spoon",
      description: "Legal notice, privacy and cookie information for Wild Spoon, private gastronomic experiences by Edu Vincent in Granada, Spain.",
    },
    notFound: {
      title: "Page not found — Wild Spoon",
      description: "The page you are looking for does not exist or has moved.",
    },
  },
  nav: {
    experiencias: "Experiences",
    cocina: "The kitchen",
    edouard: "Edu",
    galeria: "Gallery",
    opiniones: "Reviews",
    contacto: "Contact",
    reservar: "Book",
  },
  hero: {
    overline: "Wild Spoon",
    titleA: "Cooking with character.",
    titleB: "A table in the Albaicín.",
    subtitle: "Private gastronomic experiences created by Edu Vincent in the heart of the Albaicín — or directly at your home.",
    ctaPrimary: "Book an experience",
    ctaSecondary: "Discover Wild Spoon",
    note: "From 4 guests · Granada",
    scroll: "Scroll",
    imageAlt: "Edu Vincent at his Albaicín home (real photo)",
  },
  marquee: {
    words: ["fire", "instinct", "generosity", "creativity", "sharing"],
  },
  intro: {
    overline: "The concept",
    title: "Eat well, open a bottle and sit at the table — no rush.",
    p1: "Wild Spoon grew from a simple idea: eat well, open a bottle and settle around a table without hurry.",
    p2: "Edu Vincent creates private gastronomic experiences in Granada for small groups, either at his own home or by coming to yours.",
    meta: "Private dining · Albaicín, Granada · Groups from 4 guests",
  },
  menus: {
    overline: "Menus",
    title: "Three ways to sit at the table.",
    perPerson: "per person",
    note: "One menu designed for each table and each occasion. Bookings from 4 guests.",
    rows: [
      { n: "5", label: "courses", price: "75" },
      { n: "6", label: "courses", price: "90" },
      { n: "7", label: "courses", price: "100" },
    ],
  },
  twoWays: {
    overline: "Two ways to live Wild Spoon",
    title: "One table, two settings.",
    block1: {
      tag: "At Edu's home",
      title: "A table in the Albaicín",
      text: "In the heart of Granada, Edu opens the doors of his home to welcome small groups around his table. Cooking, conversation and long evenings in a home full of Albaicín character.",
      location: "Albaicín · Granada",
      note: "The exact address is shared once your booking is confirmed.",
      cta: "Book an experience",
      imageAlt: "Wild Spoon's lamb pastilla with sweet potato, served at Edu's home (real photo)",
    },
    block2: {
      tag: "Wild Spoon at your place",
      title: "Edu cooks. You enjoy.",
      text: "Wild Spoon can also come to your house, villa, apartment or rental in Granada and beyond. Edu takes care of the kitchen so you can simply take care of enjoying the table.",
      forWhom: "Ideal for:",
      list: ["Holidays in Granada", "Gatherings of friends", "Family celebrations", "Villas and country houses", "Special occasions", "Small private groups"],
      cta: "Check availability",
      imageAlt: "Cooking with character: a Wild Spoon plate (real photo)",
    },
  },
  cocina: {
    overline: "The kitchen",
    title: "No borders. No unnecessary rules.",
    lead: "A free, personal cuisine without borders: between France and Spain, carrying the memory of a Galician grandmother's kitchen, with every table in sight.",
    chapters: [
      { n: "01", t: "Fire", d: "Embers, slow cooking and intense flavours." },
      { n: "02", t: "Instinct", d: "A recipe is a starting point, never a limit." },
      { n: "03", t: "Product", d: "Every ingredient has something to say." },
      { n: "04", t: "Generosity", d: "Careful plates, but never shy ones." },
      { n: "05", t: "Memory", d: "France, Spain, Galicia, travels, family recipes." },
      { n: "06", t: "Curiosity", d: "Taking something familiar somewhere new." },
    ],
    mainImageAlt: "Slow cooking over fire in Edu's kitchen (real photo)",
    wideImageAlt: "The meat rice in the paella pan, for the middle of the table (real photo)",
    sign: "Wild Spoon — Fire. Character. Generosity.",
  },
  edouard: {
    overline: "Edu",
    name: "Edu Vincent",
    subtitle: "Self-taught cook. Franco-Catalan. Wild by nature.",
    bio: [
      "Franco-Catalan and a self-taught cook, I built my cuisine between two cultures — nourished by French and Spanish traditions and by the memories of my Galician grandmother's kitchen.",
      "My cooking is instinctive, generous and decidedly wild.",
      "I love fire, embers, slow cooking, deep sauces, acidity, crunch and honest flavours. I look for beautiful, careful plates — but never shy ones: for me, generosity is part of elegance.",
      "Above all, I like to take a dish you think you know, respect its soul, and then push it much further. Reworking textures, intensifying flavours, adding one unexpected detail… until something familiar becomes a genuine experience.",
      "I cook without borders and without unnecessary rules. With instinct, fire, creativity and one obsession: that every bite has something to say.",
      "Because for me, cooking is still, above all, a moment to share — to enjoy and sit down together around a table.",
    ],
    sign: "Wild Spoon — fire, character, generosity.",
    photoCaption: "Edu Vincent on the terrace of his Albaicín home — real photo",
    imageAlt: "Edu Vincent on his terrace, wearing a black shirt (real photo)",
  },
  testimonios: {
    overline: "Reviews",
    title: "As told by those who have sat at the table.",
    lead: "Real reviews from travellers who have lived the experience with Edu, as written on Sazón The Folk Cook, the platform where he also hosts his experiences.",
    emptyTitle: "Reviews will arrive here very soon.",
    emptyText: "We are preparing a selection of real reviews from guests who have already lived the experience.",
  },
  granada: {
    overline: "Granada",
    title: "Granada sits at the table too.",
    text: "Wild Spoon was born in the Albaicín, in the heart of Granada. A city of blended cultures, long shared dinners and flavours that have been travelling back and forth for centuries.",
    meta: "Albaicín · Granada · Spain",
  },
  sazon: {
    overline: "Track record",
    title: "Years cooking for travellers from all over the world.",
    text: "Edu also hosts gastronomic experiences through Sazón The Folk Cook.",
    cta: "View profile on Sazón",
  },
  galeria: {
    overline: "Gallery",
    title: "Moments of Wild Spoon.",
    filters: { todas: "All", platos: "Dishes", postres: "Desserts", cocina: "The kitchen", edouard: "Edu" },
  },
  ctaBand: {
    title: "Ready to sit at the table?",
    text: "Tell us the date and how many you are. Edu will personally check availability and get back to you.",
    cta: "Book your experience",
  },
  reservas: {
    overline: "Bookings",
    title: "Book your experience",
    lead: "Tell us the date, the size of your group and the experience you prefer. Edu will personally check availability. Menus of 5, 6 or 7 courses, from €75 per person.",
    notice: "Your request is not confirmed until you receive Edu's personal confirmation.",
    stepsTitle: "How it works",
    steps: [
      { t: "You send the request", d: "Tell us the date, the number of guests and the type of experience." },
      { t: "Edu reviews it", d: "He personally checks availability and reaches out to you." },
      { t: "Your table is confirmed", d: "Only once Edu confirms is your booking made." },
    ],
    form: {
      nombre: "First name",
      nombrePh: "Your first name",
      apellidos: "Last name",
      apellidosPh: "Your last name",
      email: "Email",
      emailPh: "you@email.com",
      telefono: "Phone / WhatsApp",
      telefonoPh: "+34 600 000 000",
      fecha: "Preferred date",
      personas: "Number of guests",
      personasMin: "Wild Spoon is available for groups of 4 or more.",
      tipo: "Type of experience",
      tipoEdouard: "At Edu's home — Albaicín",
      tipoEdouardHint: "Private dinner at his table, in the Albaicín",
      tipoDomicilio: "Private chef at your place",
      tipoDomicilioHint: "Edu cooks where you are staying",
      direccion: "Address or area where the experience will take place",
      direccionPh: "Rental name, street, area…",
      idioma: "Preferred language",
      idiomas: ["Español", "English", "Français", "Other"],
      alergias: "Allergies, intolerances or dietary needs",
      alergiasPh: "Tell us about any dietary needs in your group",
      mensaje: "Message / special occasion",
      mensajePh: "A celebration, an anniversary, simply a good dinner…",
      acepto: "I have read and understand that this request is subject to availability and that the booking will only be confirmed once I receive the confirmation from Wild Spoon.",
      submit: "Request availability",
      required: "Required field",
      invalidEmail: "Please enter a valid email",
      aceptoRequired: "You must accept the confirmation condition to send the request.",
      direccionRequired: "Please provide the address or area where the experience will take place.",
      fechaRequired: "Please choose a future date.",
      submitting: "Sending…",
      error: "The request could not be sent. Please try again or reach out through the contact form.",
    },
    success: {
      title: "Request received",
      p1: "Thank you for contacting Wild Spoon.",
      p2: "Edu will personally review availability for the requested date and will get in touch with you.",
      p3: "Please remember your booking is not yet confirmed.",
      cta: "Back to home",
    },
  },
  contacto: {
    overline: "Contact",
    title: "Let's talk about your table.",
    lead: "For any questions about the experiences, write to us and we will answer personally.",
    location: "Granada and surroundings",
    form: {
      nombre: "Name",
      email: "Email",
      telefono: "Phone",
      mensaje: "Message",
      submit: "Send message",
      submitting: "Sending…",
      success: "Message sent. Thank you for writing — we will reply personally.",
      error: "The message could not be sent. Please try again.",
      required: "Required field",
    },
    whatsapp: "Message us on WhatsApp",
  },
  footer: {
    brandPhrase: "Fire. Character. Generosity.",
    tagline: "Private dining in Granada. Gastronomic experiences around a table.",
    navTitle: "Discover",
    nav: { experiencias: "Experiences", reservas: "Bookings", contacto: "Contact" },
    legalTitle: "Legal",
    legal: { aviso: "Legal notice", privacidad: "Privacy", cookies: "Cookies" },
    lang: "Language",
    rights: "All rights reserved.",
  },
  legal: {
    aviso: {
      title: "Legal Notice",
      blocks: [
        { h: "Website owner", p: [
          "Owner / Data controller: Edouard Vincent.",
          "Trade name: Wild Spoon.",
          "NIE: Y4953298D.",
          "Address: Calle Carnero 4, 2B, 18010 Granada, Spain.",
          "Contact & bookings email: evincent.molas@gmail.com.",
          "Website: https://wild-spoon.com",
        ] },
        { h: "Purpose", p: [
          "Edouard Vincent operates the website https://wild-spoon.com under the trade name Wild Spoon to offer private gastronomic experiences in Granada and its surroundings, both at his own home and at the client's, as well as private cook services for groups from 4 guests.",
        ] },
        { h: "Terms of use", p: [
          "Accessing and browsing the website implies acceptance of these terms. The user agrees to make proper use of the contents and not to use them for unlawful activities.",
          "Booking requests submitted through the form do not constitute a confirmed booking: they remain subject to availability and are only confirmed when Edu personally communicates his confirmation to the client.",
        ] },
        { h: "Intellectual and industrial property", p: [
          "All contents of this site (texts, photographs, videos, logos and design) are the property of Edouard Vincent or of third parties who have authorised their use, and are protected by intellectual and industrial property law. Reproduction, distribution or transformation without authorisation is prohibited.",
        ] },
        { h: "Liability", p: [
          "The owner accepts no liability for decisions taken based on the contents published on this site, nor for damages that may arise from interferences, omissions or interruptions beyond his control.",
          "This site may contain links to third-party websites (for example, platforms where the experiences are also offered) whose contents are not under his control.",
        ] },
        { h: "Governing law and jurisdiction", p: [
          "The relationship between the owner and the user shall be governed by Spanish law. For any dispute, the parties submit to the courts of the consumer's domicile, in accordance with applicable law.",
        ] },
      ],
    },
    privacidad: {
      title: "Privacy Policy",
      blocks: [
        { h: "Data controller", p: [
          "Controller: Edouard Vincent (trade name: Wild Spoon).",
          "NIE: Y4953298D.",
          "Address: Calle Carnero 4, 2B, 18010 Granada, Spain.",
          "Email: evincent.molas@gmail.com.",
        ] },
        { h: "Data we process", p: [
          "Through the booking form: first and last name, email, phone / WhatsApp, preferred date, number of guests, type of experience, address or area (if the service is at your place), preferred language, allergies, intolerances or dietary needs and, where applicable, your message or special occasion.",
          "Through the contact form: name, email, phone (optional) and message.",
        ] },
        { h: "Purposes of processing", p: [
          "To manage booking requests.",
          "To contact the client.",
          "To organise the provision of the service.",
          "To respond to enquiries submitted through the contact form.",
          "To comply with applicable legal obligations.",
        ] },
        { h: "Legal basis", p: [
          "The performance of a contract or pre-contractual measures (Art. 6.1.b GDPR) for managing booking requests and enquiries.",
          "Consent (Art. 6.1.a GDPR) for processing allergies, intolerances or dietary needs, as data concerning health, and for the use of non-strictly-necessary cookies.",
        ] },
        { h: "Internal communications and data processors", p: [
          "Each request or message received may generate an internal notification sent to evincent.molas@gmail.com.",
          "Email delivery is carried out through Resend, a technical email delivery provider acting as data processor. Using this provider may involve international data transfers, covered by the guarantees provided for in the GDPR (standard contractual clauses or other appropriate safeguards).",
          "Data is not disclosed to third parties for marketing purposes. No commercial communications are sent without separate, explicit consent.",
        ] },
        { h: "Data retention", p: [
          "Data will be kept for the time necessary to manage the request or enquiry and, where applicable, the provision of the service, as well as for the periods required by applicable law.",
        ] },
        { h: "Your rights", p: [
          "You may exercise your rights of access, rectification, erasure, objection, restriction of processing and portability by writing to evincent.molas@gmail.com.",
          "You may also lodge a complaint with the Spanish Data Protection Agency (www.aepd.es) if you believe your rights have not been properly addressed.",
        ] },
        { h: "Security and updates to this policy", p: [
          "Appropriate technical and organisational measures are applied to protect personal data. This policy may be updated; the current version is always published on this page.",
        ] },
      ],
    },
    cookies: {
      title: "Cookie Policy",
      blocks: [
        { h: "What cookies are", p: [
          "Cookies and similar technologies (such as local storage) are small files stored on your device that allow information about your browsing to be stored and retrieved.",
        ] },
        { h: "Strictly necessary cookies", p: [
          "This site only uses storage that is strictly necessary for it to work: your selected language preference and your cookie consent state. These do not require consent.",
        ] },
        { h: "Analytics cookies", p: [
          "If you give your consent, the site loads a third-party statistics tool (PostHog) that anonymously records interaction with the pages in order to improve the experience. This only loads after acceptance and can be withdrawn at any time.",
        ] },
        { h: "How to manage or withdraw consent", p: [
          "You can accept, reject or configure cookies from the consent notice and, at any time, from the “Cookie settings” link available in the footer. Withdrawing consent is as easy as giving it.",
        ] },
      ],
    },
  },
  cookiesUI: {
    title: "Your privacy",
    text: "This site uses strictly necessary cookies to work (language and this preference) and, only with your consent, an anonymous analytics tool to improve it.",
    accept: "Accept",
    reject: "Reject",
    config: "Configure",
    save: "Save preferences",
    necessary: "Strictly necessary",
    necessaryDesc: "Selected language and your consent. Always on.",
    analytics: "Anonymous analytics",
    analyticsDesc: "Anonymous usage statistics (PostHog) to improve the site. Only loaded if you accept.",
    footerLink: "Cookie settings",
  },
  common: {
    notFoundTitle: "Page not found",
    notFoundText: "The page you are looking for does not exist or has moved.",
    backHome: "Back to home",
  },
};

export default en;
